import { createSelector } from '@ngrx/store';

import { membersState } from '../root';

export const getAccountBalance = createSelector(membersState, (members) => members.accountBalance);
